/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { SearchableItem, SearchableSelectionType } from "src/app/model/interface";



export class CensusGeo implements SearchableItem {
  code: string;
  name: any;

  active: boolean;
  allowed: boolean;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parseArray(v: any): CensusGeo[] {
    let arr = [];
    if(v && v.suggestions){
      for(let s of v.suggestions){
        let geo: CensusGeo = new CensusGeo();
        geo.name = s.title;
        geo.code = s.facets?.g;
        arr.push(geo);
      }
    }

    return arr;
  }

  getName(): string {
    return this.name;
  }

  getFullDetails(): string {
    return this.name;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
